import { createContext } from 'react';

export const CommonComponentContext = createContext({ clientConfig: {}, upsertSetting: () => {}, useSetting: () => {}, useSettingsLoading: () => true, configStatuses: () => [], glossary: {}, credentials: { username: null } });